import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-gradient-to-b from-[#0f172a] via-[#1e293b] to-[#0f172a] overflow-hidden" data-id="element-50">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-51">
        <motion.div className="absolute top-20 left-10 text-[#d4a853]/20" animate={{
        rotate: 360
      }} transition={{
        duration: 60,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-52">
          <SparklesIcon className="w-16 h-16" data-id="element-53" />
        </motion.div>
        <motion.div className="absolute top-40 right-20 text-[#d4a853]/30" animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-54">
          <MoonIcon className="w-24 h-24" data-id="element-55" />
        </motion.div>
        <motion.div className="absolute bottom-40 left-20 text-[#d4a853]/15" animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-56">
          <SparklesIcon className="w-12 h-12" data-id="element-57" />
        </motion.div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 py-16 md:py-24" data-id="element-58">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-59">
          {/* Text content */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-60">
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-61">
              Tu Bebé Dormirá{' '}
              <span className="text-[#d4a853]" data-id="element-62">6 Horas Seguidas</span> Esta
              Misma Noche{' '}
              <span className="text-[#f5c542]" data-id="element-63">(Sin Dejarlo Llorar)</span>
            </h1>

            <h2 className="font-['DM_Sans'] text-lg md:text-xl text-gray-300 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-64">
              El Método "Noche en Paz": El protocolo de 7 minutos diseñado para
              mamás agotadas que necesitan recuperar su vida, su sueño y su
              energía hoy mismo.
            </h2>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-65">
              <CTAButton data-id="element-66">¡QUIERO QUE MI BEBÉ DUERMA HOY!</CTAButton>
              <p className="text-gray-400 text-sm" data-id="element-67">
                Acceso instantáneo después del pago. Seguro y confiable.
              </p>
            </div>
          </motion.div>

          {/* Product image */}
          <motion.div className="flex-1 max-w-md lg:max-w-lg" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-68">
            <div className="relative" data-id="element-69">
              <div className="absolute inset-0 bg-[#d4a853]/20 blur-3xl rounded-full transform scale-110" data-id="element-70" />
              <img src="https://cdn.magicpatterns.com/uploads/v2DJkDeA4Q7ePxM1ZEptrf/heylloyd-image-1772411643963.png" alt="Método Noche en Paz - Guía completa para el sueño infantil" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-71" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}